import { Pipe, PipeTransform } from '@angular/core';
import { Offer } from '../../core/models/offer/offer.model';
import { mapFloatToStringWithComma } from '../utils/string-utils';

@Pipe({
  name: 'lowestFirstInstalment'
})
export class LowestFirstInstalmentPipe implements PipeTransform {

  transform(offer: Offer, args?: any): string {
    const firstInstalments = offer.premiums.map(premium => premium.instalments[0].value);
    const lowestFirstInstalment = Math.min(...firstInstalments);
    return mapFloatToStringWithComma(lowestFirstInstalment);
  }
}
